import React, { useState } from "react";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme =>
  createStyles({
    textAreaLabelContainer: {
      position: "relative"
    },
    textAreaLabel: {
      position: "absolute",
      transform: `translate(1px, 16px) scale(1)`,
      transformOrigin: "top left",
      transition: "transform .2s ease",
      padding: [[0, theme.spacing(1)]],
      pointerEvents: "none",
      color: "#818181"
    },
    inputFocused: {
      color: "#2d75ad",
      background: "#fefefe",
      visibility: "visible",
      transform: `translate(9px, 0px) scale(.75)`
    },
    root: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      minWidth: "100%",
      minHeight: "40px",
      width: "100%",
      fontSize: "0.875rem",
      "& > *": {
        fontSize: "0.875rem"
      },
      borderRadius: theme.shape.borderRadius,
      borderColor: "#c9c8c9",
      fontFamily: theme.typography.fontFamily,
      padding: theme.spacing(1),
      maxWidth: "100%",
      borderStyle: "solid",
      borderWidth: "1px",
      boxSizing: "border-box",
      "&::-webkit-input-placeholder": {
        color: "transparent"
      },
      "&:hover": {
        borderColor: "black"
      },
      "&:focus": {
        borderColor: "#2d75ad",
        borderWidth: "1px",
        outline: "0"
      }
    }
  })
);

const OSSTextarea = ({ id, label, value, ...rest }) => {
  const classes = useStyles();
  const [focused, setFocused] = useState(false);

  const labelClasses = [
    classes.textAreaLabel,
    focused || value ? classes.inputFocused : " "
  ].join(" ");

  const toggleFocused = () => {
    setFocused(!focused);
  };

  return (
    <div className={classes.textAreaLabelContainer}>
      <label className={labelClasses} htmlFor={id}>
        {label}
      </label>
      <TextareaAutosize
        className={classes.root}
        onFocus={toggleFocused}
        onBlur={toggleFocused}
        value={value}
        {...rest}
      />
    </div>
  );
};

export default OSSTextarea;
